import { EnrollmentStatus } from '@/pipeline/stateMachine';

export interface Course {
  id?: number;
  name?: string;
  descomplicaProviderCode?: string;
  descomplicaCurriculumId?: string;
}

export interface Campus {
  id?: number;
  name?: string;
  city?: string;
  state?: string;
}

export interface EnrollmentState {
  enrollmentId?: number;
  areDocumentsSent?: boolean;
  enrollmentStatus?: EnrollmentStatus;
  partnerCode?: string;
  course?: Course;
  campus?: Campus;
  hasErrorVoucher?: boolean;
  isComplementaryModuleEnabled?: boolean;
  backofficeStudentAcademicRecord?: string;
}

const enrollment: EnrollmentState = {
  enrollmentId: undefined,
  areDocumentsSent: undefined,
  enrollmentStatus: undefined,
  partnerCode: undefined,
  course: undefined,
  campus: undefined,
  hasErrorVoucher: undefined,
  isComplementaryModuleEnabled: undefined,
  backofficeStudentAcademicRecord: undefined,
};

export default enrollment;
